<template>
    <div class="view-login view">
        <loginHeader />
        <div class="banner-container">
            <el-carousel id="carousel" :interval="5000">
                <template v-if="!ads || ads.length == 0">
                    <el-carousel-item>
                        <div class="login-ad">
                            <img
                                src="@/assets/img/loginPage/login_background.png"
                                style="height: 100%; width: 100%"
                            />
                        </div>
                    </el-carousel-item>
                </template>
                <template v-else>
                    <el-carousel-item v-for="item in ads" :key="item.imgid">
                        <div class="login-ad">
                            <template v-if="!item.imgid">
                                <img
                                    src="@/assets/img/loginPage/login_background.png"
                                    style="height: 100%; width: 100%"
                                />
                            </template>
                            <template v-else>
                                <a
                                    v-if="item.linkurl"
                                    :href="item.linkurl"
                                    :target="item.opentype !== '3' ? '_self' : '_blank'"
                                >
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </a>
                                <div>
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </div>
                            </template>
                        </div>
                    </el-carousel-item>
                </template>
            </el-carousel>
            <div class="login-main">
                <div class="login-comp-container">
                    <!-- <div class="login-panel" :style="{ top: login_top + 'px' }"> -->
                    <div class="login-panel">
                        <div class="login-body">
                            <div class="login-cert-type">
                                <div class="left-btn">个人登录</div>
                                <div class="right-btn">
                                    <div class="resetlogin-btn" v-on:click.once="forgetPwd">
                                        <p class="text">忘记密码</p>
                                    </div>
                                    <div
                                        v-if="$util.getBusinessModule('0A1')"
                                        class="openAcconunt-btn"
                                        v-on:click="register"
                                    >
                                        <p>免费开户</p>
                                    </div>
                                </div>
                                <!-- <div v-if="$const.institutionaLogin" class="middle-line"></div>
                                <div
                                    v-if="$const.institutionaLogin"
                                    class="right-btn"
                                    v-on:click="jumpToInstitutionaLogin"
                                >
                                    机构登录
                                </div> -->
                            </div>
                            <div class="login-form">
                                <el-form
                                    ref="loginForm"
                                    :rules="rules"
                                    :model="loginForm"
                                    label-width="0"
                                    v-on:keyup.enter.native="login"
                                >
                                    <el-form-item
                                        v-if="loginCertType === '1'"
                                        label=""
                                        prop="phone"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.phone"
                                            :maxlength="11"
                                            placeholder="请输入手机号码"
                                            prefix-icon="fa fa-mobile"
                                        />
                                    </el-form-item>
                                    <el-form-item
                                        v-if="loginCertType === '1'"
                                        label=""
                                        prop="smscode"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.smscode"
                                            class="reset-pwd"
                                            :maxlength="6"
                                            placeholder="请输入验证码"
                                            prefix-icon="fa fa-lock"
                                        >
                                            <span
                                                slot="append"
                                                type="text"
                                                class="reset-btn"
                                                :class="{ grey: count > 0 }"
                                                v-on:click="getVerifyCode"
                                            >
                                                {{
                                                    count > 0 ? `重新获取(${count}s)` : "获取验证码"
                                                }}
                                            </span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="!automaticrecognition && loginCertType === '2'"
                                        label=""
                                        prop="certType"
                                        class="icon-select"
                                    >
                                        <i class="fa fa-id-card select-card" aria-hidden="true" />
                                        <el-select
                                            v-model="loginForm.certType"
                                            placeholder="请选择证件类型"
                                            v-on:change="checkCertNoAgain"
                                        >
                                            <el-option
                                                v-for="item in certTypes"
                                                :key="item.subitem"
                                                :label="item.subitemname"
                                                :value="item.subitem"
                                            />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="loginCertType === '2'"
                                        label=""
                                        prop="certNo"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.certNo"
                                            :maxlength="20"
                                            :placeholder="
                                                loginForm.certType === '000'
                                                    ? '请输入基金账号'
                                                    : automaticrecognition
                                                    ? '请输入手机号/证件号/基金账号'
                                                    : '请输入证件号码'
                                            "
                                            prefix-icon="fa el-icon-user-solid"
                                        />
                                    </el-form-item>
                                    <el-form-item
                                        v-if="loginCertType === '2' && showImgCode"
                                        label=""
                                        prop="verifyCode"
                                    >
                                        <el-input
                                            v-model="loginForm.verifyCode"
                                            placeholder="请输入验证码"
                                            :maxlength="4"
                                            prefix-icon="fa fa-shield"
                                        >
                                            <span slot="append" class="prop-verify">
                                                <img
                                                    id="verifyImg"
                                                    :src="imgSrc"
                                                    v-on:click="refresh"
                                                />
                                            </span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="loginCertType === '2'"
                                        label=""
                                        prop="password"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.password"
                                            type="password"
                                            class="reset-pwd"
                                            :maxlength="32"
                                            placeholder="请输入密码"
                                            prefix-icon="fa fa-lock"
                                            v-on:keydown.native="detectCapsLock"
                                        ></el-input>
                                        <div
                                            class="capsLock-tip js-capsLock"
                                            :class="{ hide: !capsLock }"
                                        >
                                            <i class="capsLockTip-triangle" aria-hidden="true" />
                                            大写锁定已打开
                                        </div>
                                    </el-form-item>
                                    <el-form-item v-if="protocol.length > 0" class="protocol">
                                        <div class="privacy-agreement">
                                            <el-checkbox
                                                v-model="checkbox"
                                                size="small"
                                            ></el-checkbox>
                                            <span class="grey">我已阅读并同意</span>
                                            <span v-for="item in protocol" :key="item.id">
                                                <a
                                                    v-if="item.opentype === '1'"
                                                    class="red"
                                                    :href="$util.imgSrc({ fileCode: item.fileid })"
                                                    target="_blank"
                                                >
                                                    《{{ item.title }}》
                                                </a>
                                                <span v-else class="red" v-on:click="argRead(item)">
                                                    《{{ item.title }}》
                                                </span>
                                            </span>
                                        </div>
                                    </el-form-item>
                                    <el-form-item
                                        class="login-btn"
                                        :style="
                                            protocol.length > 0
                                                ? 'margin-top:12px'
                                                : 'margin-top:55px'
                                        "
                                    >
                                        <el-button
                                            type="primary"
                                            class="login-n"
                                            :class="span24"
                                            v-on:click="login"
                                        >
                                            立即登录
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div v-if="loginRedirectAddress.length > 0" class="login-redirect">
                                <div
                                    v-for="(item, index) in loginRedirectAddress"
                                    :key="index"
                                    class="item"
                                    v-on:click="$util.openLink(item.address)"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                            <div v-if="$util.getConfig().hideFunc" class="bottom-click-type">
                                <div
                                    v-if="showTradeNotice"
                                    class="left-btn"
                                    v-on:click="$util.openLink($const.zxTradingNoticeLink)"
                                >
                                    交易须知
                                </div>
                                <!-- <div class="middle-line"></div>
                                <div class="right-btn">帮助手册</div>
                                <div class="middle-line"></div>
                                <div class="right-btn">操作演示</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <zx-footer></zx-footer>
        <img-code
            v-if="loginCertType === '1'"
            :dialog-visible="dialogVisible"
            :biztype="$const.IMG_BIZTYPE.SMSLOGIN"
            v-on:verify-in="sendSms"
        />
        <smsValid
            :dialog-visible="smsVisible"
            sms-type="1"
            :mobileno="mobileno"
            :en-mobileno="en_mobileno"
            :certificateno="loginForm.certNo"
            :show-remote="showRemote"
            :biz-type="$const.IMG_BIZTYPE.TWOFACTORAUTH"
            v-on:sms-comfirm="formValidSuccess('1')"
            v-on:close="smsVisible = false"
        />
        <my-dialog
            :title="agrData.title"
            :visible.sync="agrVisible"
            :dialog-close="agrVisibleHdie"
            width="800px"
        >
            <div class="protocol-detail" v-html="agrData.content"></div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                    确定
                </el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import loginHeader from "@/components/layout/loginHeader.vue";
import zxFooter from "@/components/layout/zxFooter.vue";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import imgCode from "@/components/layout/imgCode.vue";
import commonApi from "@/api/common";
import smsValid from "@/components/form/smsValid.vue";
import myDialog from "@/components/layout/myDialog.vue";
import { sceneEnum } from "@/util/util_jfit";
export default {
    components: {
        zxFooter,
        loginHeader,
        imgCode,
        smsValid,
        myDialog
    },
    data() {
        return {
            imgRefresh: null,
            ad_ratio: 3, // 轮播广告图片的长宽比
            ad_width: 0,
            ad_height: 0, // 轮播广告图片高度，由setPageSize方法计算后赋值
            login_top: "10",
            ads: [],
            loginType: [
                { id: "1", name: "手机号登录" },
                { id: "2", name: "证件号登录" } // 暂不支持其他登录方式
            ],
            /* { id: "1", val: "QQ账号", url: "qq_icon" }, */
            others: [{ id: "2", val: "微信登录", url: "wx_icon", name: "wxbind" }],
            certTypes: [], // 证件类型
            loginForm: {
                phone: "",
                password: "",
                smscode: "",
                verifyCode: "",
                certType: "00",
                certNo: ""
            },
            imgSrc: "",
            loginUser: "enduser",
            loginCertType: "",
            capsLock: false,
            rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                certNo: [{ validator: this.checkCertNo, trigger: "change" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                smscode: [
                    {
                        validator: this.validateSmscode,
                        trigger: "blur"
                    }
                ],
                verifyCode: [
                    {
                        validator: this.$util.validateImgVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            /* wx跳转 */
            wxLoginParam: {},
            timer: "",
            count: -1,
            locked: false,
            loginloading: false,
            registerFlag: false,
            defaultImg: require("@/assets/img/loginPage/login_background.png"),
            dialogVisible: false,
            smsVisible: false,
            mobileno: "",
            en_mobileno: "",
            protocol: [],
            agrType: sceneEnum.login, // 协议类型，登录协议
            checkbox: false, // 阅读确认
            agrData: {},
            agrVisible: false,
            showRemote: false,
            showImgCode: false,
            showTradeNotice: false,
            automaticrecognition: false, // 证件类型自动识别
            loginRedirectAddress: [], // 登录页跳转地址
            twoFactorLoginData: null // 用来缓存首次 login 返回的数据
        };
    },
    computed: {
        span24() {
            return this.registerFlag ? "" : "span-24";
        }
    },
    created() {
        sessionStorage.setItem("alreadyread", "");
        sessionStorage.removeItem("daystoexpiredFlag");
        sessionStorage.removeItem("daystoexpiredFlag");
        this.getImgInfo();
        this.$cache.initCityCountyList();
        if (this.$util.getConfig().onlyPrivateFund) {
            this.loginType.length = 1;
        }

        // 是否展示交易须知
        this.showTradeNotice =
            this.$cache.getParamValue("account_info") &&
            this.$cache.getParamValue("account_info").showtradenotice;
    },
    mounted() {
        this.automaticrecognition = this.$cache.getCompanyInfoParam("10114003") == "1";
        // this.smsVisible = true; // 临时代码
        this.showImgCode = sessionStorage.getItem("showImgCode") === "1";
        if (this.showImgCode) {
            this.$nextTick(() => {
                this.refresh();
            });
        }
        document.body.onresize = (function (o) {
            return function () {
                o.setPageSize();
            };
        })(this);
        this.certTypes = (this.$cache.getDict("130007") &&
            JSON.parse(JSON.stringify(this.$cache.getDict("130007")))) || [
            {
                dictitem: "130007",
                itemorder: 0,
                itemtype: null,
                subitem: "00",
                subitemname: "身份证",
                sysid: 100
            }
        ];
        this.certTypes = this.certTypes.concat([
            {
                dictitem: "130007",
                subitem: "000",
                subitemname: "基金账号",
                sysid: "4"
            }
        ]);
        let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
        if (findIndex >= 0) {
            this.certTypes[findIndex].subitemname = `身份证/手机号`;
        }
        if (
            this.$cache.getParams().function_mask &&
            this.$cache.getParams().function_mask.indexOf("0") > -1
        ) {
            this.loginType = this.loginType.filter((item) => {
                return item.id != "1";
            });
        }
        this.getRedirectUrls();
        this.setPageSize();
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.imgRefresh = setInterval(
            (function (o) {
                return function () {
                    o.refresh();
                };
            })(this),
            3 * 60 * 1000
        );
        this.getUrlParam();
        this.checkEncWay();
        this.loginCertType = this.$util.getConfig().isPhoneLog ? "1" : "2";
        if (this.loginCertType === "2") {
            this.refresh();
        }
        this.getAgreement();
        // 查询现金宝信息
        this.cfgFundrealtimeQueryAll();
        sessionStorage.removeItem("_showSpecial");
    },
    beforeDestroy() {
        clearInterval(this.imgRefresh);
    },
    methods: {
        getRedirectUrls() {
            const paramValue = this.$cache.getCompanyInfoParam("10105012") || "";
            if (paramValue) {
                try {
                    this.loginRedirectAddress = JSON.parse(paramValue);
                } catch (e) {
                    this.loginRedirectAddress = [];
                }
            }
        },
        agrVisibleHdie() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        getAgreement() {
            this.$util.getProtocol(this.agrType).then((res) => {
                this.protocol = res;
            });
        },
        // 查询现金宝信息
        async cfgFundrealtimeQueryAll() {
            let res = await fundApi.cfgFundrealtimeQueryAll();
            let xjbfundcode = res.data && res.data[0] && res.data[0].fundcode;
            if (!xjbfundcode) {
                sessionStorage.setItem("xjbFundInfo", JSON.stringify({}));
            } else {
                const res1 = await fundApi.getFundLists({
                    fundcode: xjbfundcode,
                    pagesize: 10,
                    pagenum: 1
                });
                let xjbFundInfo = (res1.data.list && res1.data.list[0]) || {};
                sessionStorage.setItem("xjbFundInfo", JSON.stringify(xjbFundInfo));
            }
            // 获取基金公司现金宝的名字
            let obj = this.$cache.getParamValue("fund_info");
            sessionStorage.setItem("xjbName", (obj && obj.xjbname) || "现金宝");
        },
        /* 处理banner宽度和高度 */
        setPageSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w = w < 1200 ? 1200 : w;
            this.ad_width = w;
            this.ad_height = w / this.ad_ratio;
            if (this.ad_height < 500) {
                this.ad_height = 500;
                this.ad_width = this.ad_height * this.ad_ratio;
            }
            // 登录表单位置计算
            this.login_top = (this.ad_height - 470) / 2;
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.loginForm.certType === `00` && value.length === 11) {
                // 身份证号/手机号混合登录
                const regex = /^1[3-9]\d{9}$/;
                if (regex.test(value)) {
                    callback();
                } else {
                    callback(new Error(`请输入正确格式的手机号`));
                }
                return;
            }
            if (value === "") {
                callback(
                    new Error(
                        this.loginForm.certType === "000"
                            ? "请输入基金账号"
                            : this.automaticrecognition
                            ? "请输入手机号/证件号/基金账号"
                            : "请输入证件号码"
                    )
                );
                return;
            }
            if (this.loginForm.certType !== "000") {
                if (this.automaticrecognition) {
                    callback();
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
                }
            } else {
                callback();
            }
        },
        /* 短信验证码 */
        validateSmscode(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                const reg = /^[0-9a-zA-Z]{6,6}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("验证码应为6位数字"));
                }
            }
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
        },
        // 判断是否开启大写输入
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        /* 刷新验证码图片 */
        refresh() {
            this.$util.imgUrl().then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            this.$router.push({
                name: "retrievepwd",
                query: { tit: "找回密码" }
            });
        },
        /* 表单重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // 解决表单切换
            this[formName].phone = "";
            this[formName].certNo = "";
            this[formName].password = "";
        },
        /* 表单登录 */
        login() {
            const _this = this;
            if (this.loginloading) return;
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    const h = this.$createElement;
                    if (this.protocol.length > 0 && !this.checkbox) {
                        let protocolChildren = [h("span", null, "点击确定，表示您已阅读并同意")];
                        const commonProps = {
                            class: "red"
                        };
                        this.protocol.forEach(function (item) {
                            if (item.opentype === "1") {
                                protocolChildren.push(
                                    h(
                                        "a",
                                        {
                                            ...commonProps,
                                            attrs: {
                                                href: _this.$util.imgSrc({ fileCode: item.fileid }),
                                                target: "_blank"
                                            }
                                        },
                                        "《" + item.title + "》"
                                    )
                                );
                            } else {
                                protocolChildren.push(
                                    h(
                                        "span",
                                        {
                                            ...commonProps,
                                            on: {
                                                click: () => _this.argRead(item)
                                            }
                                        },
                                        "《" + item.title + "》"
                                    )
                                );
                            }
                        });
                        this.$msgbox({
                            title: "提示",
                            message: h("div", null, protocolChildren),
                            showCancelButton: true,
                            confirmButtonText: "确定",
                            type: "warning",
                            customClass: "info-check",
                            beforeClose: (action, instance, done) => {
                                if (action === "confirm") {
                                    _this.checkbox = true;
                                    _this.formValidSuccess();
                                    done();
                                } else {
                                    done();
                                }
                            }
                        });
                    } else {
                        _this.formValidSuccess();
                    }
                    return false;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 快捷注册 */
        register() {
            if (this.loginUser === "enduser") {
                this.$router.push({
                    name: "register",
                    query: { tit: "快速开户" }
                });
            }
        },
        async getImgInfo() {
            // const res = await commonApi.getBannerAds({
            //     bannerType: "101",
            //     pageSize: "10",
            //     pageNum: "1"
            // });
            // if (res.error) return;
            let info = this.$cache.getParams();
            let bannerList;
            try {
                bannerList = JSON.parse(info["10105001"].paramvalue);
            } catch (e) {
                console.log(e);
            }
            for (let i in bannerList) {
                bannerList[i].imgid = this.$util.imgSrc({
                    fileCode: bannerList[i].fileid
                });
            }
            this.ads = bannerList;
        },
        getVerifyCode(val) {
            if (this.count > 0) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    if (!this.showImgCode) {
                        this.sendSms("1");
                    } else {
                        this.dialogVisible = true;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        sendSms(val) {
            this.dialogVisible = false;
            if (!val) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    try {
                        const { data } = await userApi.loginSms(
                            {
                                mobileno: this.loginForm.phone,
                                verifycode: val
                            }
                            // 示例：如果想要某些返回码也通过校验，通过自定义validateCode配置项实现
                            // {
                            //     validateCode: (code) => {
                            //         return code === 0 || code === "0";
                            //     },
                            // }
                        );
                        this.locked = true;
                        this.count = data.sendperiod;
                        this.counting();
                        this.$message({
                            type: "success",
                            message: "验证码已发送"
                        });
                    } catch (e) {
                        this.refresh();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        /* 登录表单验证成功 */
        // async formValidSuccess(smsFlag) {
        //     if (!this.locked && this.loginCertType === "1") {
        //         this.$message({
        //             type: "warning",
        //             message: "请先发送手机短信验证码"
        //         });
        //         return false;
        //     }
        //     // 同意留痕
        //     commonApi.agreementLeaveTracesLog(
        //         this,
        //         {
        //             eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/M",
        //             eventname: `协议同意`
        //         },
        //         this.protocol
        //     );
        //     const loginPwd = this.$util.enc(this.loginForm.password);
        //     let accttype = "";
        //     if (this.loginCertType === "1") {
        //         // 手机短信登录
        //         accttype = "8";
        //     }
        //     if (this.loginCertType === "2") {
        //         accttype = this.loginForm.certType === "000" ? "2" : "0";
        //     }
        //     let _data = {
        //         accttype: accttype,
        //         logintype: this.loginCertType === "1" ? "02" : "05",
        //         certificatetype: this.loginForm.certType === "000" ? "" : this.loginForm.certType,
        //         certificateno: this.loginForm.certNo,
        //         verifycode: this.loginForm.verifyCode,
        //         smscode: this.loginForm.smscode,
        //         pwd: loginPwd,
        //         mobileno: this.loginForm.phone
        //     };
        //     // 校验手机号登录方式
        //     const regex = /^1[3-9]\d{9}$/;
        //     if (
        //         regex.test(this.loginForm.certNo) &&
        //         this.loginCertType === "2" &&
        //         !this.automaticrecognition
        //     ) {
        //         _data.logintype = `05`;
        //         _data.certificatetype = ``;
        //         _data.certificateno = ``;
        //         _data.accttype = `8`;
        //         _data.mobileno = this.loginForm.certNo;
        //     }
        //     if (this.loginCertType == "2" && this.automaticrecognition) {
        //         _data.accttype = `*`;
        //         _data.certificatetype = ``;
        //     }
        //     if (this.loginCertType === "2" && smsFlag !== "1") {
        //         // 判断是否异地登录
        //         let param = {
        //             accttype: _data.accttype,
        //             pwd: _data.pwd,
        //             certificatetype: _data.certificatetype,
        //             certificateno: _data.certificateno,
        //             invtp: "1",
        //             mobileno: _data.mobileno,
        //             biztype: this.$const.IMG_BIZTYPE.OTHER
        //         };
        //         if (this.loginCertType === "2" && this.showImgCode) {
        //             param.verifyCode = this.loginForm.verifyCode;
        //         }
        //         const res = await userApi.acctBeforeLoginCheck(param).catch((data) => {
        //             if (data.code === "14010001") {
        //                 this.showImgCode = true;
        //                 this.refresh();
        //                 sessionStorage.setItem("showImgCode", "1");
        //             }
        //         });
        //         // res.data.remoteloginflag = "1"; // 临时代码
        //         // res.data.en_mobileno = "";// 临时代码
        //         // res.data.mobileno = "";// 临时代码
        //         if (
        //             res.code === "0" &&
        //             (res.data.remoteloginflag === "1" ||
        //                 res.data.firstLoginflag === "1" ||
        //                 res.data.everyLoginflag === "1")
        //         ) {
        //             if (
        //                 res.data.remoteloginflag === "1" &&
        //                 res.data.firstLoginflag !== "1" &&
        //                 res.data.everyLoginflag !== "1"
        //             ) {
        //                 this.showRemote = true;
        //             }
        //             // 密码验证通过
        //             this.mobileno = res.data.mobileno;
        //             this.en_mobileno = res.data.en_mobileno;
        //             this.smsVisible = true;
        //             return;
        //         }
        //     }
        //     try {
        //         this.loginloading = true;
        //         const res = await userApi.login(_data);
        //         if (res.error) {
        //             this.loginloading = false;
        //             return;
        //         }
        //         const { data } = res;
        //         this.$cache.setBinded(data.others.isbind === "1");
        //         this.$cache.setHeadImage(data.others.headimage ? data.others.headimage : "");
        //         // 前端塞入的登录信息
        //         data.others.accttype = _data.accttype;
        //         this.$cache.setUserOtherInfo(data.others);
        //         sessionStorage.setItem("_showWarn", "");
        //         sessionStorage.setItem("_showBankCard", "");
        //         sessionStorage.setItem("_showIdCardHolder", "");
        //         this.$store
        //             .dispatch("login", {
        //                 key: this.loginForm.phone,
        //                 ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
        //                 userinfo: data.others,
        //                 userName: data.userName
        //             })
        //             .then(() => {
        //                 if (data.others.isbind === "1") {
        //                     this.$router.push("/home");
        //                 } else {
        //                     this.$confirm(
        //                         "您的账户尚未开户，暂时无法进行购买/定投基金等交易功能，是否立即前往开户",
        //                         "温馨提示",
        //                         {
        //                             confirmButtonText: "确定",
        //                             cancelButtonText: "暂不开户",
        //                             type: "warning"
        //                         }
        //                     )
        //                         .then(() => {
        //                             this.$router.push({
        //                                 name: "bindacctway"
        //                             });
        //                         })
        //                         .catch(() => {
        //                             this.$router.push("/home");
        //                         });
        //                 }
        //             })
        //             .catch((e) => {
        //                 this.loginloading = false;
        //                 console.log("login error", e);
        //             });
        //     } catch (e) {
        //         this.loginloading = false;
        //         this.refresh();
        //     }
        // },

        // ==========================
        // 表单校验成功入口(新的)
        // ==========================
        async formValidSuccess(smsFlag) {
            // ==========================
            // 双因素校验成功回调（前置）
            // ==========================
            if (smsFlag === "1") {
                const { data, accttype } = this.twoFactorLoginData || {};
                if (!data) {
                    this.$message.error("登录状态失效，请重新登录");
                    return;
                }

                this.finishLogin(data, accttype);

                this.twoFactorLoginData = null;
                this.smsVisible = false;
                this.loginloading = false;
                return;
            }

            if (!this.locked && this.loginCertType === "1") {
                this.$message({
                    type: "warning",
                    message: "请先发送手机短信验证码"
                });
                return;
            }

            // 同意留痕
            commonApi.agreementLeaveTracesLog(
                this,
                {
                    eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/M",
                    eventname: "协议同意"
                },
                this.protocol
            );

            const loginPwd = this.$util.enc(this.loginForm.password);

            let accttype = "";
            if (this.loginCertType === "1") accttype = "8";
            if (this.loginCertType === "2") {
                accttype = this.loginForm.certType === "000" ? "2" : "0";
            }

            let _data = {
                accttype,
                logintype: this.loginCertType === "1" ? "02" : "05",
                certificatetype: this.loginForm.certType === "000" ? "" : this.loginForm.certType,
                certificateno: this.loginForm.certNo,
                verifycode: this.loginForm.verifyCode,
                smscode: this.loginForm.smscode,
                pwd: loginPwd,
                mobileno: this.loginForm.phone
            };

            // 手机号自动识别登录
            const regex = /^1[3-9]\d{9}$/;
            if (
                regex.test(this.loginForm.certNo) &&
                this.loginCertType === "2" &&
                !this.automaticrecognition
            ) {
                _data = {
                    ..._data,
                    logintype: "05",
                    certificatetype: "",
                    certificateno: "",
                    accttype: "8",
                    mobileno: this.loginForm.certNo
                };
            }

            if (this.loginCertType === "2" && this.automaticrecognition) {
                _data.accttype = "*";
                _data.certificatetype = "";
            }

            try {
                this.loginloading = true;
                const res = await userApi.login(_data).catch((data) => {
                    if (data.code === "14010001") {
                        this.showImgCode = true;
                        this.refresh();
                        sessionStorage.setItem("showImgCode", "1");
                    }
                });
                if (res.error) {
                    this.loginloading = false;
                    return;
                }

                const { data } = res;

                // ==========================
                // 双因素判断
                // ==========================
                const twoFlag = data && data.others && data.others.twofactorauthflag;
                if (["1", "2", "3"].includes(String(twoFlag))) {
                    this.twoFactorLoginData = {
                        data,
                        accttype: _data.accttype
                    };

                    this.mobileno = data.others.mobileno;
                    this.en_mobileno = data.others.en_mobileno;
                    this.showRemote = twoFlag === "2";
                    this.smsVisible = true;
                    this.loginloading = false;
                    return;
                }

                // ==========================
                // 普通登录完成
                // ==========================
                this.finishLogin(data, _data.accttype);
            } catch (e) {
                this.loginloading = false;
                this.refresh();
            }
        },

        // ==========================
        // 登录完成统一处理
        // ==========================
        finishLogin(data, accttype) {
            this.$cache.setBinded(data.others.isbind === "1");
            this.$cache.setHeadImage(data.others.headimage || "");

            // 前端塞入登录信息
            data.others.accttype = accttype;
            this.$cache.setUserOtherInfo(data.others);

            sessionStorage.setItem("_showWarn", "");
            sessionStorage.setItem("_showBankCard", "");
            sessionStorage.setItem("_showIdCardHolder", "");

            this.$store
                .dispatch("login", {
                    key: this.loginForm.phone,
                    ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                    userinfo: data.others,
                    userName: data.userName
                })
                .then(() => {
                    if (data.others.isbind === "1") {
                        this.$router.push("/home");
                    } else {
                        this.$confirm(
                            "您的账户尚未开户，暂时无法进行购买/定投基金等交易功能，是否立即前往开户",
                            "温馨提示",
                            {
                                confirmButtonText: "确定",
                                cancelButtonText: "暂不开户",
                                type: "warning"
                            }
                        )
                            .then(() => {
                                this.$router.push({ name: "bindacctway" });
                            })
                            .catch(() => {
                                this.$router.push("/home");
                            });
                    }
                })
                .catch((e) => {
                    this.loginloading = false;
                    console.log("login error", e);
                });
        },
        loginFromWX(list) {
            // this.$router.push({name: list.name});
            if (this.loginUser === "enduser") {
                let backurl = encodeURIComponent(window.location.href);
                let appid = this.$cache.getCompanyInfo().wechat_web_appid || "";
                window.location.href =
                    "https://open.weixin.qq.com/connect/qrconnect?appid=" +
                    this.$cache.getCompanyInfo().wechat_web_appid +
                    "&redirect_uri=" +
                    backurl +
                    "&response_type=code&scope=snsapi_login&state=" +
                    this.$cache.getSessionToken() +
                    "#wechat_redirect";
            }
        },
        // 获取URL查询参数
        getUrlParam() {
            var queryStr = location.href;
            var targetUrl = queryStr.substr(queryStr.indexOf("?") + 1).split("&");
            targetUrl.forEach((f) => {
                this.$set(this.wxLoginParam, f.split("=")[0], f.split("=")[1]);
            });
            if (this.wxLoginParam.code) this.wxlogin();
        },
        // wx是否绑定，是否直接微信登录
        wxlogin() {
            const _this = this;
            this.$req({
                url: "/oauth/wechat",
                data: this.wxLoginParam,
                method: "POST"
            })
                .then((res) => {
                    // 绑定状态
                    if (res.code === "0000000") {
                        if (res.record[0][0].bound === "0") {
                            _this.$router.push({ name: "wxbind" });
                        } else {
                            _this.$store
                                .dispatch("login", {
                                    key: res.record[0][0].aeskey,
                                    token: res.record[0][0].token
                                })
                                .then(() => {
                                    _this.$router.push("/home");
                                });
                        }
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        },
        /* 查看柜台是否开启国密 */
        checkEncWay() {
            sessionStorage.setItem("isOpenGMEnc", "0");
            sessionStorage.setItem("hasBankRroute", "0");
            /* this.$util.getGtParamsValue ("1001164",res => {
                if(res.paramvalue.indexOf("A90") > -1) {
                    sessionStorage.setItem("isOpenGMEnc", "1");
                }else {
                    sessionStorage.setItem("isOpenGMEnc", "0");
                }
                if(res.paramvalue.indexOf("A32") > -1) {
                    sessionStorage.setItem("hasBankRroute", "1");
                }else {
                    sessionStorage.setItem("hasBankRroute", "0");
                }
            }); */
        },
        counting() {
            if (this.timer) this.timer = null;
            this.timer = setInterval(() => {
                if (this.count > 0) {
                    this.count -= 1;
                }
            }, 1000);
        },
        // 加载默认图片
        handleError(e) {
            e.target.src = this.defaultImg;
        },
        jumpToInstitutionaLogin() {
            if (this.$cache.getCompanyInfoParam("10105006")) {
                let url = this.$cache.getCompanyInfoParam("10105006");
                window.open(url, "_blank");
            } else {
                this.$message.warning("暂未配置");
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.view-login {
    position: relative;

    .banner-container {
        width: 100%;
        height: 100%;
        min-height: 700px;
        position: relative;
        #carousel {
            img {
                min-height: 700px;
            }
        }
        .el-carousel {
            height: 700px;
            min-height: 700px;
            .el-carousel__container {
                height: 100%;
            }
        }
    }
    .bottom-click-type {
        margin-top: 30px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        .left-btn,
        .right-btn {
            padding: 0 6px;
            color: var(--color-text-primary);
            cursor: pointer;
            user-select: none;
        }
        .left-btn {
            text-align: right;
        }
        .middle-line {
            width: 2px;
            height: 12px;
            background-color: var(--color-divided);
        }
    }
    .login-main {
        z-index: 10;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        right: 200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around; /* 设置水平方向上子元素的分布 */
        align-items: center;
        gap: 24px;

        .login-comp-container {
            position: relative;
            .login-panel {
                box-shadow: 0 0 5px var(--color-border-base);
                .el-tabs__content {
                    background-color: var(--color-bg-page);
                }
                width: 315px;
                box-sizing: border-box;
                z-index: 999;
                background: $bg2;
                padding: 24px 34px;
                border-radius: 6px 6px;
                overflow-x: hidden;
                overflow-y: auto;
                .el-tabs__header.is-top {
                    margin: 0;
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0;
                }
                .el-tabs__active-bar {
                    background: var(--color-primary);
                }
                .el-tabs__item {
                    width: 380px;
                    padding: 0;
                    font-size: 20px;
                    color: var(--color-text-accent);
                    text-align: center;
                    &.is-active {
                        color: var(--color-primary);
                    }
                }
                .login-cert-type {
                    display: flex;
                    align-items: baseline;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .left-btn,
                    .right-btn {
                        flex: 1;
                        color: var(--color-text-accent);
                        cursor: pointer;
                    }
                    .left-btn {
                        font-weight: 500;
                        font-size: 22px;
                        color: var(--color-text-regular);
                    }
                    .right-btn {
                        font-weight: 400;
                        font-size: 12px;
                        color: var(--color-text-regular);
                        line-height: 12px;
                        text-align: right;
                        font-style: normal;
                        display: flex;
                        .resetlogin-btn {
                            border-bottom: 1px solid var(--color-text-regular);
                        }
                        .openAcconunt-btn {
                            margin-left: 16px;
                            color: var(--color-primary);
                            border-bottom: 1px solid var(--color-primary);
                        }
                    }
                    .middle-line {
                        width: 2px;
                        height: 25px;
                        background-color: var(--color-divided);
                    }

                    .el-radio {
                        display: inline-block;
                        width: 156px;
                        margin-right: 0;
                        text-align: left;
                        padding-left: 24px;
                        .el-radio__label {
                            line-height: 24px;
                            font-size: 16px;
                        }
                        .el-radio__input.is-checked + .el-radio__label {
                            color: $text-color2;
                        }
                    }
                    .el-radio + .el-radio {
                        margin: 0;
                    }
                }
                .login-other {
                    padding: 15px 10px 15px 13px;
                    .login-other-box {
                        display: inline-block;
                        .other-list {
                            cursor: pointer;
                            margin-right: 20px;
                            display: inline-block;
                            .other-list-img {
                                vertical-align: middle;
                                width: 23px;
                                height: 23px;
                                display: inline-block;
                            }
                            .other-list-text {
                                color: $text-color3;
                                margin-left: 5px;
                                vertical-align: middle;
                            }
                        }
                    }
                    .login-btn-msg {
                        display: inline-block;
                        vertical-align: middle;
                        color: $text-color1;
                        .d-login {
                            color: $color-b;
                            // float: right;
                            padding: 0;
                            span {
                                line-height: 23px;
                                display: inline-block;
                            }
                        }
                    }
                }
                .login-form {
                    background: $bg2;
                    .span-24 {
                        width: 232px;
                        height: 44px;
                        // background: linear-gradient(90deg, #f64148 0%, #d20a11 100%);
                        background: var(--color-primary);
                        box-shadow: 0px 1px 7px 0px rgba(243, 10, 25, 0.13),
                            0px 1px 5px 0px rgba(255, 81, 47, 0.11);
                        border-radius: 4px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #ffffff;
                    }
                    .el-form-item {
                        &.icon-select {
                            position: relative;
                        }
                        &.login-btn {
                            text-align: center;
                            margin-bottom: 0;
                            .login-n {
                                font-size: $f16;
                            }
                        }
                        .fa.fa-id-card.select-card {
                            position: absolute;
                            z-index: 1000;
                            font-size: $f20;
                            color: var(--color-text-weak);
                            top: 11px;
                            left: 6px;
                        }
                        margin-bottom: 16px;
                        .el-select {
                            .el-input__inner {
                                padding-left: 40px;
                            }
                        }
                        .el-input {
                            border-bottom: 1px solid var(--color-border-base);
                            .el-input__inner {
                                border: none;
                                border-radius: 0;
                                padding-left: 40px;
                            }
                            .el-input__icon {
                                font-size: $f20;
                            }
                        }
                        .el-form-item__error {
                            width: 100%;
                            text-indent: 40px;
                            font-size: $f14;
                            color: $color-c;
                            padding: 4px 0;
                            z-index: 2;
                            font-family: "element-icons", sans-serif !important;
                            font-style: normal;
                            font-weight: normal;
                            font-variant: normal;
                            text-transform: none;
                            line-height: 1;
                            vertical-align: baseline;
                            display: inline-block;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                            background-position-y: center;
                        }
                        .el-col.el-col-19 {
                            .el-form-item--small.el-form-item {
                                margin-bottom: 0px;
                            }
                        }
                        .reset-pwd .el-input-group__append {
                            width: 38px;
                        }
                        .el-input-group__append {
                            color: var(--color-primary);
                            border: none;
                            background: none;
                            padding: 0;
                            cursor: pointer;
                            .reset-btn {
                                padding: 0;
                            }
                            .grey {
                                color: var(--color-text-primary);
                            }
                            .prop-verify {
                                height: 38px;
                                float: right;
                            }
                        }
                    }
                }
            }
        }
        .el-carousel {
            width: 817px;
            height: 468px;
            overflow: hidden;
        }
    }
    :deep(.el-checkbox .el-checkbox__inner:after) {
        border-width: 2px;
        left: 4px;
        height: 8px;
        width: 4px;
    }
    :deep(input.el-input__inner) {
        font-size: 16px;
    }
}
.dc-other-container {
    display: flex;
    width: calc(100% - 0px);
    justify-content: space-around; /* 设置水平方向上子元素的分布 */
    gap: 24px;
    .otheritem {
        flex: 1;
        font-size: 12px;
        color: var(--color-text-accent);
        background-color: var(--color-bg-container);
        border-radius: 2px;
        cursor: pointer;
        &:hover {
            color: var(--color-text-primary);
        }
    }
}
.margin-top12 {
    margin-top: 12px;
}
#verifyImg {
    width: 93px;
    height: 38px;
}
.privacy-agreement {
    color: var(--color-text-primary);
    margin-top: 14px;
    line-height: 16px;
    font-size: 12px;
    .grey {
        margin-left: 4px;
    }
    .red {
        color: $bg18;
        cursor: pointer;
    }
}
.protocol-detail {
    padding: 20px 10px;
    max-height: 60vh;
    min-height: 10vh;
    overflow: scroll;
}
</style>

<style lang="scss" scoped>
:deep(.el-form-item) {
    margin-bottom: 10px !important;

    &.check {
        margin-bottom: 10px;
        .el-checkbox-group {
            height: 40px;
        }
        .el-form-item__error--inline {
            display: block;
        }
    }
}

:deep(.el-input__inner) {
    border-radius: 2px;
}
:deep(.footer-container) {
    width: 100%;
}
.privacy-agreement {
    :deep(.el-checkbox) {
        .el-checkbox__inner {
            width: 16px;
            height: 16px;
            &::after {
                transform: rotate(45deg) scaleY(0.7);
                top: -2px;
                left: 2px;
            }
        }
    }
}
.login-redirect {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    height: 40px;
    gap: 24px;

    .item {
        flex: 1;
        font-size: 12px;
        color: var(--color-text-accent);
        background-color: var(--color-bg-container);
        border-radius: 2px;
        justify-content: center;
        align-items: center;
        display: flex;
        cursor: pointer;
        &:hover {
            color: var(--color-text-primary);
        }
    }
}
</style>
